"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.construct = void 0;
/**
 * Create a variant based on a class.
 * @param cls class definition / constructor
 * @returns a variant creator that wraps the class constructor into a factory function.
 */
function construct(cls) {
    return ((...args) => new cls(args));
}
exports.construct = construct;
